// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__20riK","name":"footer_name__26_9S","rights":"footer_rights__dNNBf"};